import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AdminProvider } from './admin/context/AdminContext';

// Frontend Components
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import BackToTop from './components/BackToTop';

// Frontend Pages
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import ServiceDetail from './pages/Services/ServiceDetail';
import Gallery from './pages/Gallery';

// Admin Pages
import AdminApp from './admin/AdminApp';

import './App.css';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { 
    window.scrollTo(0, 0); 
  }, [pathname]);
  return null;
}

function App() {
  return (
    <AdminProvider>
      <Router>
        <ScrollToTop />
        <Routes>
          {/* Admin panel logic remains same */}
          <Route path="/admin/*" element={<AdminApp />} />

          {/* Clean Front-end routes */}
          <Route path="/*" element={
            <>
              <Navbar />
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/services" element={<Services />} />
                <Route path="/services/:serviceType" element={<ServiceDetail />} />
                <Route path="/gallery" element={<Gallery />} />
              </Routes>
              <Footer />
              <BackToTop />
            </>
          } />
        </Routes>
      </Router>
    </AdminProvider>
  );
}

export default App;